/**
 * Created by Ning Jiang on 2/7/2018.
 */
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline, TimelineLite} from "gsap";
import {TractorBeamGameConfig} from "../../TractorBeamGameConfig";
import {TractorBeamSoundConfig} from "../../TractorBeamSoundConfig";
import {TractorBeamBigWinView} from "./TractorBeamBigWinView";

export class TractorBeamBigWinController extends StepCountUpBigWinController {

    private _gameView:TractorBeamBigWinView;
    protected _winSymbols:StateReelSymbol[] = [];
    private _symbolWinStates:boolean[][];
    protected _noWinSymbols:StateReelSymbol[] = [];
    private _betLineData:any;

    private _reelsNum:number = 5;
    private _symbolsNum:number = 3;

    constructor(indexes:[number, number]) {
        super(indexes, {skipLastLevelCountUpIfSmall : true, skippableOnEachLevel:true});

        this._gameView = new TractorBeamBigWinView();
    }

    protected parseFeatureGameData(data:ParsedGameData):void {
        super.parseFeatureGameData(data);

        this._symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(this._reelsNum, () => {
            return ArrayHelper.initArrayWithValues<boolean>(this._symbolsNum, () => {return false;})
        });

        this._winSymbols.length = 0;
        this._noWinSymbols.length = 0;
        this._betLineData = data.betWins;
    }

    private calculateWinSymbols(blData:any):void {
        const symbolsNum:number = blData.nrOfSymbols | 0;
        let symbol:StateReelSymbol | null = null;

        for(let i:number = 0; i < symbolsNum; i++) {
            symbol = Reels.getSymbol(i, blData.betLine[i]); //this.findSymbol(i, blData.betLine[i]);
            if(symbol && this._winSymbols.indexOf(symbol) === -1) {
                this._winSymbols.push(symbol);
            }
        }

        let noWinSymbol:StateReelSymbol | null;
        for(let i:number = 0; i < this._symbolWinStates.length; i++) {
            for(let j:number = 0; j < this._symbolWinStates[i].length; j++) {

                if(this._symbolWinStates[i][j]) {
                    continue;
                }
                noWinSymbol = Reels.getSymbol(i, j);

                if(noWinSymbol) {
                    this._noWinSymbols.push(noWinSymbol);
                }
                /*if (noWinSymbol == null || !noWinSymbol.visible) {
                    continue;
                }*/

                /*tl.add(noWinSymbol.changeState({
                    state: OwlWarriorsGameConfig.instance.SYMBOL_STATES.noWin!,
                    fadeInDuration: 0.5
                }), 0.2);*/
            }
        }
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        if(level == 0) {
            this._gameView.preCalculateCountScale(this._gameData!.totalWin);
            this._betLineData.forEach((blData:any) => {
                this.calculateWinSymbols(blData);
            });
        }
        const tl:TimelineLite = new TimelineLite();
        const delay:number = level == 0 ? 0 : 0; //Wait for symbol animation on firs level.
        const bigWin:TimelineLite = this._gameView.getBigWinLevelAnimation(level, level == this._winLevel);
        tl.add((level === 0) ? () => {
            this._winSymbols.forEach((symbol:StateReelSymbol) => {
                //const symbol:BasicStateReelSymbol | null = <BasicStateReelSymbol> Reels.getSymbol(2, symbolId);

                if(symbol) {
                    symbol!.changeState({
                        state : TractorBeamGameConfig.instance.SYMBOL_STATES.win
                    }, undefined);
                }
            });

            this._noWinSymbols.forEach((symbol:StateReelSymbol) => {
                //const symbol:BasicStateReelSymbol | null = <BasicStateReelSymbol> Reels.getSymbol(2, symbolId);

                if(symbol && symbol.symName !== "S") {
                    symbol!.changeState({
                        state : TractorBeamGameConfig.instance.SYMBOL_STATES.noWin
                    }, undefined);
                }
            });

            SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.BIG_WIN_START);
        } : () => {

        });
        tl.add(bigWin, delay);
        return tl;
    }


    protected playCountUp(from:number, to:number, duration:number, preTotalWin?:number):Timeline | null {
        return this._gameView.getCountUp(from, to, duration);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        /*if(this._gameData == undefined) {
        }*/
        const totalWin:number = this._gameData!.totalWin;
        const singleWin:number = this._gameData!.singleWin;
        const tl:TimelineLite = this._gameView.getEndingAnimation(isAborted, this._winLevel, singleWin);
        //tl.add(() => DungeonQuest.soundPlayer.stopEffect(DungeonQuestSound.BIG_WIN_WINDUP), 0);
        tl.add(() => SlotGame.winFieldController.showWinField(totalWin), 0);
    }
}
